module.exports = require('./helpers/bundle-url').getBundleURL('5FFt5') + "logo.7718c6df.svg";